<template>
	<div
		class="resource-planning-user-select-skeleton"
		:aria-label="$t('spa__general.loading')"
	>
		<div class="resource-planning-user-select-skeleton__row">
			<SuiSkeleton is-circle width="3.5rem" />
			<SuiSkeleton height="1.75rem" width="50%" />
		</div>
		<div class="resource-planning-user-select-skeleton__row">
			<SuiSkeleton is-circle width="3.5rem" />
			<SuiSkeleton height="1.75rem" width="70%" />
		</div>
		<div class="resource-planning-user-select-skeleton__row">
			<SuiSkeleton is-circle width="3.5rem" />
			<SuiSkeleton height="1.75rem" width="40%" />
		</div>
		<div class="resource-planning-user-select-skeleton__row">
			<SuiSkeleton is-circle width="3.5rem" />
			<SuiSkeleton height="1.75rem" width="60%" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { SuiSkeleton } from '@developers/scoro-ui';
</script>

<style lang="scss">
.resource-planning-user-select-skeleton {
	&__row {
		width: 100%;
		display: flex;
		align-items: center;
		gap: 1rem;
		padding: 1rem 2rem 1rem 1rem;
	}
}
</style>
